export default __webpack_public_path__ + "static/media/video1.92b7caac.mp4";